import React from "react";
import { useNavigate } from "react-router-dom";
import CpdIllustration from "../../../assets/images/CDP_Illustration.png";
import Illustration from "../../../assets/images/Illustration.png";
import { PromoRow } from "./components/cards";
import { useWarehouseMetrics } from "./warehouse-metrics-api";

// Both buttons here used to render with no `onButtonClick` at all (dead —
// clicking either did nothing). "Unify Profiles" and "Explore Live Profiles"
// are two different destinations, not duplicate CTAs for the same page: the
// CDP Unify dashboard (identity stitching) vs the live Profile Explorer.
export const UnifyProfilesSection: React.FC = () => {
  const navigate = useNavigate();
  const { loading, findMetric, formatValue } = useWarehouseMetrics();
  const metric = findMetric("overview", ["contacts_to_unify", "unified_profiles"], ["Available contacts to unify"]);
  return (
    <PromoRow
      title="Unify Connected Profiles"
      description="Understand every customer with a single view of their identity, activity, and engagement."
      count={formatValue(metric)}
      countLabel="Available contacts to unify"
      buttonLabel="Unify Profiles"
      illustration={<img src={CpdIllustration} alt="Unify Connected Profiles" className="h-auto max-h-40" />}
      onButtonClick={() => navigate("/unify/dashboard")}
      loading={loading}
      isSample={metric?.is_sample}
    />
  );
};

export const ExploreProfilesSection: React.FC = () => {
  const navigate = useNavigate();
  const { loading, findMetric, formatValue } = useWarehouseMetrics();
  const metric = findMetric("overview", ["profiles_to_explore"], ["Available profiles to explore"]);
  return (
    <PromoRow
      title="Explore unified customer profiles in one place"
      description="Understand every customer with a single view of their identity, activity, and engagement."
      count={formatValue(metric)}
      countLabel="Available profiles to explore"
      buttonLabel="Explore Live Profiles"
      illustration={<img src={Illustration} alt="Explore unified customer profiles" className="h-auto max-h-40" />}
      onButtonClick={() => navigate("/unify/profiles")}
      loading={loading}
      isSample={metric?.is_sample}
    />
  );
};
